import React from 'react';
import { useAvatarSrc } from '../../utils/hooks/useAvatarSrc';
var AvatarPlaceholder = function (_a) {
    var className = _a.className;
    var imgSrc = useAvatarSrc();
    return (React.createElement("div", { className: className },
        React.createElement("img", { src: imgSrc, alt: "" })));
};
AvatarPlaceholder.displayName = 'AvatarPlaceholder';
export default AvatarPlaceholder;
//# sourceMappingURL=AvatarPlaceholder.js.map